export const BLOCKED_PROPERTIES = ["availability"];
export const WORKFLOW_ROLES_TABLE_SECTION_KEY = "workflow_roles_table";
